import { render } from "./DropZone.vue?vue&type=template&id=f404f66e&ts=true"
import script from "./DropZone.vue?vue&type=script&lang=ts"
export * from "./DropZone.vue?vue&type=script&lang=ts"

import "./DropZone.vue?vue&type=style&index=0&id=f404f66e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__